import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=348480ca&"
import script from "./groups.vue?vue&type=script&lang=js&"
export * from "./groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports